---
title: My Development Environment Setup and Coding Workflow
coverImage: /blog/assets/images/dev-env.webp
date: 2023-10-29T16:02:03.000Z
updated: 2023-10-30T15:39:05.000Z
excerpt: How I set up my machine to work on software
hidden: true
tags:
  - SDLC
---

<script>import CodeBlock from "@lib/components/molecules/CodeBlock.svelte";</script>

## Introduction

> Give me six hours to chop down a tree and I will spend the first four sharpening the axe. <br> Abraham Lincoln

## Coding Workflow

Discuss the pros and cons of using different text editors and integrated development environments (IDEs).
Provide step-by-step instructions for setting up Visual Studio Code, Sublime Text, and Atom.
Discuss the advantages of using version control systems such as Git.
Explain how to use Git to manage code changes and collaborate with other developers.

### SDLC

_Explain the importance of having a consistent coding workflow._

Doing any task becomes a lot easier when there's little friction required to start the task. This is especially true in coding, because half of the hard work is knowing what to write. I love when I log on and immediately know what I need to do, so I try to maintain a todo list or kanban board.

Planning: This phase involves defining the scope of the project and identifying the requirements.
Design: In this phase, the team designs the software architecture and creates a detailed design document.
Coding: The coding phase involves writing code based on the design document.
Testing: In this phase, the team tests the software to ensure that it meets the requirements.
Deployment: Once the software has been tested and approved, it is deployed to production.
Maintenance: The maintenance phase involves fixing bugs and making updates to the software as needed.

### Daily

Each day the code I write starts in my editor, tested incrementally with linting and builds, then tested for functionality with a test suite. After I complete a task, it goes into a Change / Pull request for review and get's merged.

Each day I execute my plan.
Gather / specify requirements -> tests, research / design a solution -> documentation, code, commit + review

### Weekly

Each week I plan out my work.
What tasks, what order, what dependencies

### Monthly

Each month I review my projects and adjust my long term calendar items.
work schedule, exercise times, coding times,

## Conclusion

Summarize the key points discussed in the blog post.
Encourage readers to share their own tips and tricks for setting up a development environment and coding workflow.
